import { Component, OnDestroy, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

import { FilterTypeModel } from '../../models/abstract-filter-type.model';
import { ChipModel } from '../../../Forms/models/chip.model';
import { FilterService } from '../../services/abstract-filter.service';
import { ChipContainerComponent } from '../../../Forms/components/ChipContainer/chip-container.component';
import { ReachFilterModel } from '../../../TargetingShared/model/reach-filter.model';
import { AgprComponentStyleEnum } from '../../../Basic/enums/social-analysis-types.enum';
import { MonitoringKeywordFilterModel } from '../../../../Monitor/Shared/models/monitoring-keyword-filter.model';

@Component({
    selector: 'agpr-filter-chips',
    templateUrl: './filter-chips.component.html',
    styleUrls: ['./filter-chips.component.scss'],
    standalone: false
})
export class FilterChipsComponent implements OnInit, OnDestroy {
    @ViewChild('chipContainer') chipContainer: ChipContainerComponent;

    @Input() id: string;
    @Input() overflowMessage: string = 'Common.filter.overflowMessage';
    @Input() emptyMessage: string = 'Common.filter.emptyMessage';
    @Input() noContainerWhenEmpty: boolean = false;
    @Input() readonly: boolean = false;
    @Input() style: AgprComponentStyleEnum = AgprComponentStyleEnum.social;

    @Output() chipsRemoved: EventEmitter<void> = new EventEmitter<void>();

    subscriptions: Subscription[] = [];
    filters: FilterTypeModel<any>[];

    chips: ChipModel[] = [];

    chipGroups: {
        label: string;
        chips: ChipModel[];
    }[] = [];

    constructor(
        private filterService: FilterService
    ) { }

    ngOnInit(): void {
        this.subscriptions.push(
            this.filterService.getFlatFilters().subscribe(
                (flatFilters) => {
                    // Display keyword filter chips first
                    this.filters = [
                        ...flatFilters.filter(x => x instanceof MonitoringKeywordFilterModel),
                        ...flatFilters.filter(x => !(x instanceof MonitoringKeywordFilterModel)),
                    ];
                    this.refreshChips();
                }
            )
        );
    }

    /**
     * Refreshes the list of chips
     */
    refreshChips(): void {
        this.chips = [];
        this.chipGroups = [];

        this.filters.forEach((filter) => {
            if (filter instanceof ReachFilterModel) {
                if (filter.hasValueSet()) {
                    this.chips.push(...filter.chips);

                    this.chipGroups.push({
                        label: filter.label,
                        chips: filter.chips
                    });
                }
            } else if (filter && filter.chips && filter.chips.length) {
                this.chips.push(...filter.chips);

                this.chipGroups.push({
                    label: filter.label,
                    chips: filter.chips
                });
            }
        });
    }
    /**
     * Removes a chip from the filters
     * @param index Index of the chip to be removed
     */
    removeChip(index: number): void {
        const chip: ChipModel = this.chips[index];

        const filter = this.filters
            .find(filterTypeModel => {
                return !!filterTypeModel.chips?.find(_chip => {
                    return chip.label === _chip.label
                        && chip.labelArgs === _chip.labelArgs
                        && chip.tooltip === _chip.tooltip;
                });
            });

        filter.removeChip(chip);

        this.filterService.applyFilters();
        this.chipsRemoved.emit();
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
        this.subscriptions = [];
    }
}
